<igx-grid #gridCiudades  [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [sortingOptions]="sortingOptions"
  [rowEditable]="true" [primaryKey]="'IdCiudad'" (rowEditEnter)="rowEditEnter($event)" (rowEditExit)="rowEditExit()"
  (rowEditDone)="addUpdateCiudad($event)" (rowEdit)="validarCiudad($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()"
  [igxGridState]="optionsGridLocal" (columnInit)="onColumnInit($event)" [moving]="true" (keydown)="customKeydown($event)"
          paste-handler-neodata (onDataProcessed)="datosPegadosDesdeExcel($event)" (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Ciudad" header="{{ 'GRIDS.CIUDAD.COL_CIUDAD' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxHeader #ciudadHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CIUDAD.COL_CIUDAD' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #ciudadEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="Ciudad" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="20"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="DescripcionCiudad" header="{{ 'GRIDS.CIUDAD.COL_DESCRIPCION' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #descripcionCiudadHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CIUDAD.COL_DESCRIPCION' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #desCiudadEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="DescripcionCiudad" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text"  maxlength="40"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  @if (false) {
    <igx-column field="IdEstado" [disableHiding]="true" />
  }
  <igx-column field="CodigoEstado" header="{{ 'GRIDS.CIUDAD.COL_ESTADO' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #edoDescripcionHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CIUDAD.COL_ESTADO' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #estadoDescripcionEditorTemplate let-cell="cell">
      <igx-input-group>
        <input #inputCodigoEstado igxInput name="CodigoEstado" type="text" [(ngModel)]="cell.editValue" uppercase [readOnly]="true"
               (keydown)="stopPropagationPegado($event)"/>
        <igx-suffix>
          <button title="{{ 'MENSAJES.GRALS.BUSCAR_REGISTRO_CATALOGO' | translate }}" igxButton="contained" (buttonClick)="onOpen(inputCodigoEstado)">
            <igx-icon>search</igx-icon>
          </button>
        </igx-suffix>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <!--Acciones Editar, Agregar y Borrar-->
  @if (showActionStrip) {
    <igx-action-strip #actionstrip>
      <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
        <igx-icon>add</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon>delete</igx-icon>
      </button>
    </igx-action-strip>
  }
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu" [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
